import React, { Component } from "react";

import { Checkbox } from "antd";
import moment from "moment";

import StyledScrollbar from "../../Common/UIComponents/StyledScrollbar";
import DocumentsMenuOption from "./DocumentsMenuOption";
import "./DocumentsListView.css";

export default class DocumentsListView extends Component {
  render() {
    const {
      files,
      readOnly,
      handleCheckbox,
      handleCheckboxAll,
      selectAll,
      handleFileOptionClick,
      handleNameChange,
      handleNameSubmit,
      handleRenameFile,
      handleDownloadFile,
      handleConfirmDelete,
      selectedFile,
    } = this.props;

    return (
      <StyledScrollbar
        disableTrackYWidthCompensation
        disableTracksWidthCompensation
        className="DocumentsListViewScrollbar"
      >
        <table className="docFileTable">
          <thead className="DocFileTable__Thead">
            <tr className="DocFileTableHeadInside">
              <th className="docCheckBoxCol">
                <Checkbox
                  onChange={handleCheckboxAll}
                  checked={Boolean(selectAll)}
                  aria-label="Select all files"
                />
              </th>
              <th className="DocListView__TableNameCol">Name</th>
              <th className="DocListView__TableTypeCol">Type</th>
              <th className="DocListView__TableSizeCol">Size</th>
              <th className="DocListView__TableDateCol">Date Uploaded</th>
              {/* <th className="docSortByFilter">
                Sort by
                <select className="sortByFilterOptions" name="" id="">
                  <option value="Name">Name</option>
                  <option value="Most Recent">Most Recent</option>
                  <option value="Oldest">Oldest</option>
                </select>
              </th>
              <th>
                <div
                  className="docViewButton"
                  onClick={() => this.handleChangeView()}
                >
                  Card View
                </div>
              </th> */}
            </tr>
          </thead>

          <tbody className="docFileTableBody">
            {files.map((file) => (
              <tr
                onClick={(e) => handleCheckbox(e, file.key)}
                key={file.key}
                className={file.checked ? "docSelectedFile DocFileTableBody__tr" : "DocFileTableBody__tr"}
              >
                <td className="DocFileTableBody__td">
                  <span onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                      onChange={(e) => handleCheckbox(e, file.key)}
                      checked={Boolean(file.checked)}
                      aria-label={`Select ${file.name}`}
                    />
                  </span>
                </td>
                <td className="DocListView__TableNameCol">
                  {file.renameDisable ? (
                    file.renameValue
                  ) : (
                    <input
                      disabled={file.renameDisable}
                      className={
                          !file.renameDisable
                            ? " docFileNameInput docFileNameInputEdit"
                            : "docFileNameInput"
                        }
                      onChange={(e) => handleNameChange(e, file.key)}
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => handleNameSubmit(e, file.key)}
                      type="text"
                      value={file.renameValue}
                    />
                  )}
                </td>
                <td className="DocListView__TableTypeCol">{file.extension.toUpperCase()}</td>
                <td className="DocListView__TableSizeCol">{file.fileSize}</td>
                <td className="DocListView__TableDateCol">
                  <div className="DocListView__TableDateCol__Content">
                    <div className="DocListView__TableDateCol__Content__Text">{moment(new Date(file.uploadDate)).format("lll")}</div>
                    {!readOnly && (
                      <DocumentsMenuOption
                        optionFile={file}
                        selectedFile={selectedFile}
                        handleRenameFile={() => handleRenameFile(null, file)}
                        handleConfirmDelete={() => handleConfirmDelete(null, file, false)}
                        handleDownloadFile={() => handleDownloadFile(null, file, false)}
                        handleFileOptionClick={(e) => handleFileOptionClick(e)}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </StyledScrollbar>
    );
  }
}
